<script lang="ts">
	//import Katex from './Katex.svelte'
	import {uqn} from './stores';
	let type: number, biggest: number, compare:number, choices: number;
	$: type = Number($uqn.toString()[0]);
	$: biggest = Number($uqn.toString()[1]);
	$: compare = Number($uqn.toString()[2]);
	$: choices = Number($uqn.toString()[3]);

	let digits: string, min:number;
	$: digits = storeToDigitsString(type,biggest,choices);
	$: min = compare * Math.pow(10,biggest-1);
	$: marks = type==3? 2 : 4;

	const numberWords = ['four','five','six'];

	function storeToDigitsString(t:number,b:number,c:number){
		let biggestNumber = b;
		if (type != 1){
			biggestNumber = c;
		}
		let array = [];
		for (let i = 1; i <= biggestNumber; i++){
			array.push(i);
		}
		return array.toString();
	}
</script>

{#if type==1}
	<p> 
		The digits {digits} are arranged randomly to form a {numberWords[biggest-4]}-digit number. No digit is repeated. Find the number of arrangements such that
	</p>
{:else}
	<p> 
		Digits from {digits} are used to form a {numberWords[biggest-4]}-digit number.
		{#if type==2}
			No digit is repeated.
		{:else}
			Repetitions are allowed.
		{/if}
		Find the number of arrangements such that
	</p>
{/if}
<div>
	<p>
		(a) (1 mark) the number is greater than {min},
	</p>
	<p>(b) (2 marks) the last two digits are both even,</p>
	<p>(c) ({marks} marks) the number is greater than {min} and odd.</p>
</div>